import { fetchWithAuth } from "./AuthService";

export const getUserProfile = async (token) => {
  const response = await fetch('/api/profile', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des données du profil.');
  }

  return response.json();
};

export const resendVerificationEmail = async (email) => {
  const response = await fetchWithAuth('/api/profile/resend-verification-email', {
    method: 'PUT',
    body: JSON.stringify({ email }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null; // si le backend ne renvoie pas de JSON
  }

  if (!response.ok) {
    const error = new Error(data?.message || "Erreur lors de l'envoi de l'email de vérification.");
    error.response = { status: response.status, data };
    throw error;
  }

  return data;
};

export const updateUserProfile = async (profileData) => {
    //console.log("Update profile");
    const response = await fetchWithAuth('/api/profile', {
      method: 'PUT',
      body: JSON.stringify(profileData),
    });
  
    // if (!response.ok) {
    //   throw new Error('Erreur lors de la mise à jour des données du profil.');
    // }
  
    // return await response.json();

    let data = null;
    try {
      data = await response.json();
    } catch {
      data = null; // si le backend ne renvoie pas de JSON
    }

    if (!response.ok) {
      const error = new Error(data?.message || "Erreur lors de la mise à jour du profil.");
      error.response = { status: response.status, data };
      throw error;
    }

    return data;
  };

  export const updateUserLanguage = async (language) => {
  //console.log("Get Profile Lang");
  const response = await fetchWithAuth('/api/profile/language', {
    method: 'PUT',
    // headers: {
    //   'Content-Type': 'application/json',
    //   Authorization: `Bearer ${token}`,
    // },
    body: JSON.stringify({ language }),
  });

  if (!response.ok) {
    throw new Error('Erreur lors de la mise à jour de la langue.');
  }

  return await response.json();
};

export const getSubscriptionStatus = async (token) => {
  const response = await fetchWithAuth('/api/subscription/status', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération du statut d'abonnement");
  }
  return response.json();
};

export const getPaymentHistory = async (token) => {
  const response = await fetchWithAuth('/api/subscription/history', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erreur lors de la récupération de l'historique de paiement");
  }
  return response.json();
};